import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';

import { normalizePromoteFormData, type PromoteFormData } from '../../formData';

type Result = {
	promoteFormData: PromoteFormData | null;
};

export function useMapPageDataToFormData(): Result {
	const { data } = usePsfPromoteOrSharePageData();
	const utilityContext = useUtilityContext();

	const { promoteFormData } = normalizePromoteFormData({
		petition: data.petition,
		viewer: data.promoteFormRawData?.viewer,
		featureConfigs: data.promoteFormRawData?.featureConfigs,
		utilityContext,
		promoteShareVariation: data.promoteShareOnComboExperiment.variation,
	});

	return {
		promoteFormData,
	};
}
